<template>
  <el-container>
    <el-header class="table-header">
      <el-button size="small" type="primary" @click="submit(form)">{{$t('common.Save')}}</el-button>
    </el-header>
    <el-main class="table-main">
      <el-form :model="form" size="mini" label-width="90px" :rules="CommitForm" ref="form" class="table-form">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('base.info.menu.ChooseSystem')" prop="systemId">
              <el-select v-model="form.systemId" size="mini">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.menu.MenuCode')" prop="code">
              <el-input v-model.trim="form.code"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.menu.MenuNameCn')" prop="nameCn">
              <el-input v-model.trim="form.nameCn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.menu.MenuNameEn')" prop="nameEn">
              <el-input v-model.trim="form.nameEn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.menu.ComponentUrl')" prop="componentUrl">
              <el-input v-model.trim="form.componentUrl"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.menu.MatchPath')" prop="matchPath">
              <el-input v-model.trim="form.matchPath"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.menu.HiddenFlag')" prop="hiddenFlag">
              <el-select v-model="form.hiddenFlag" size="mini">
                <el-option v-for="item in optionsFlag" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.menu.Parent')" prop="parentNameCn">
              <el-input v-model="form.parentNameCn" readonly>
                <el-button slot="append" size="mini" icon="el-icon-search" @click="openTree"></el-button>
              </el-input>
              <template>
                <el-dialog :title="$t('base.info.menu.ChooseParent')" :visible.sync="dialogFormVisible" width="30%" top="4vh" :close-on-click-modal="false">
                  <el-tree :data="tree" :props="defaultProps" :expand-on-click-node="false" node-key="id"
                           default-expand-all :empty-text="$t('common.NoData')" ref="changeparent"
                           highlight-current @node-click="handleNodeClick">
                  </el-tree>
                  <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="comfirm">{{$t('common.Ok')}}</el-button>
                    <el-button @click="dialogFormVisible = false">{{$t('common.Cancel')}}</el-button>
                  </div>
                </el-dialog>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('common.Status')" prop="status">
              <template>
                <el-radio-group v-model="form.status">
                  <el-radio :label="40">{{$t('common.Disable')}}</el-radio>
                  <el-radio :label="50">{{$t('common.Normal')}}</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('common.Type')" prop="type">
              <template>
                <el-radio-group v-model="form.type">
                  <el-radio :label="'D'">{{$t('base.info.menu.Catalog')}}</el-radio>
                  <el-radio :label="'U'">{{$t('base.info.menu.Link')}}</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('common.Remark')" prop="remark">
              <el-input v-model="form.remark" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('base.info.menu.IconsUrl')" prop="iconsUrl">
              <el-input v-model="form.iconsUrl" v-if="false"></el-input>
              <file-upload :config="uploadConfig" @success="getFile"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
import FileUpload from '@/components/FileUpload'

export default {
  data () {
    return {
      options: [],
      formSearch: [],
      optionsFlag: [{
        value: 'Y',
        label: 'true'
      }, {
        value: 'N',
        label: 'false'
      }],
      form: {
        status: 50,
        type: 'D'
      },
      tableData_Url: [],
      tree: [],
      dialogFormVisible: false,
      dialogUrl: false,
      parentId: '',
      currentRow: '',
      uploadConfig: {
        type: 'photo',
        'initFileList': []
      },
      defaultProps: {
        children: 'children',
        label: 'label',
        id: 'id'
      },
      nodeData: {
        id: '',
        label: '',
        nameEn: ''
      }
    }
  },
  computed: {
    CommitForm () {
      return {
        name: [{required: true, trigger: 'blur', message: this.$t('common.NotEmpty')}],
        code: [{required: true, trigger: 'blur', message: this.$t('common.NotEmpty')}],
        systemId: [{required: true, trigger: 'change', message: this.$t('base.info.menu.PleaseChooseSystem')}],
        remark: [{max: 90, message: this.$t('common.OverLength')}]
      }
    }
  },
  components: {
    FileUpload
  },
  methods: {
    getFile (fileList) {
      this.$refs['form'].clearValidate()
      this.$set(this.form, 'iconsUrl', fileList.accessPath)
    },
    submit (form) {
      this.$refs.form.validate(valid => {
        if (valid) {
          let obj = this.options.find(item => {
            return item.value === form.systemId
          })
          form.systemName = obj.label
          let param = {data: form}
          this.$api.menuList.menuInsert(param).then((response) => {
            if (response.data.status === 'Y') {
              this.$message({
                message: response.data.message,
                type: 'success'
              })
              this.$store.dispatch('newRoutes')
            } else {
              this.$message({
                message: response.data.message,
                type: 'error'
              })
            }
            this.cancel()
          }).catch((error) => {
            console.log(error)
          })
        }
      })
    },
    openTree () {
      if (this.form.systemId === undefined) {
        this.$alert('请先选择系统')
      } else {
        let param = {
          data: {
            systemId: this.form.systemId,
            id: this.form.id
          }
        }
        this.$api.menuList.menuFindWhenUpdate(param).then((response) => {
          this.tree = response.data.data
        })
        this.dialogFormVisible = true
      }
    },
    cancel () {
      this.$router.push({path: '/menuList'})
      let tabItem = this.$store.getters.rightNav
      this.$store.dispatch('removeTab', {tabItem, fullPath: this.$route.fullPath, router: this.$router})
    },
    handleNodeClick (data) {
      this.nodeData.id = data.id
      this.nodeData.label = data.label
      this.nodeData.nameEn = data.nameEn
    },
    comfirm () {
      this.form.parentNameCn = this.nodeData.label
      this.form.parentNameEn = this.nodeData.nameEn
      this.form.parentId = this.nodeData.id
      this.dialogFormVisible = false
    },
    initSysData () {
      this.$api.systemList.systemSelect().then((response) => {
        response.data.data.map((value, i) => {
          this.options.push({label: value.name, value: value.id})
        })
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  created () {
    this.initSysData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/syssetting/menuAdd.vue